module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-143.be250eed.svg";